var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-wrapper',{attrs:{"is-center-content":"","is-pull-refresh":""},on:{"pull-reload":_vm.checkOnline}},[_c('be-placeholder-content',{attrs:{"icon":_vm.NotFound,"title":'No internet connection'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }